/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map, finalize } from 'rxjs/operators';

import { NzModalService } from 'ng-zorro-antd/modal';
import { NzSelectItemInterface } from 'ng-zorro-antd/select';

import { getEndpointsCheckedKeys, transformArray } from '../../../core/helpers';
import { HelpersInterface } from '../../../core/interfaces';
import { CompanyInterface, PartnerInterfaceGlobal, PlatformInterface, SelectItemsInterface } from '../../../core/models';
import { schainStatusItems } from '../../../core/constants';
import { RtbConnectionMode } from '../../../core/enum';
import {
  AppOptionsService,
  AuthService,
  DynamicFormService,
  ErrorsHandlingService,
  NotificationService
} from '../../../core/services';

import {
  removedRtbDSPFields,
  rtbDSPCheckboxes,
  vastDSPCheckboxes,
  removedVastDSPFields,
  removedPreBidDSPFields,
  preBidDSPCheckboxes,
  removedJsDSPFields,
  jsDSPCheckboxes
} from '../../../core/constants';
import { ErrorValidator } from '../../../core/validators';
import { AppConfig } from '../../../core/configs';

import {
  CompaniesNewComponent,
  CompaniesTestLinkComponent
} from '../../companies/modals';

import {
  JsAcceptDialogComponent,
  NotificationComponent,
  ValidationEndpointModalComponent
} from '../../../shared/components';

import { GeneralSchainService } from '../../source-schain/services';

import {
  MainDashboardInterface,
  allowTriggerItems,
  auctionTypesItems,
  connectionTypeEndpointLabelForDSP,
  dspConnections,
  apiLinkValidationStatus,
  macrosListJsDSP,
  marginKeys,
  nativeVersionsItems,
  playerSizesItems,
  pmPrebidFraudIVTItems,
  pmPrebidSuspiciousIVTItems,
  requiredFieldsForDSP,
  endpointValidationStatusItems,
  defaultMacrosListVastDSP,
} from '../models';
import { MainService } from './main.service';
import { MacrosListComponent } from '../components';
import { EndpointLinkDialogComponent, ConsentConfirmComponent } from '../modals';
import { SourceSchainInterface } from '../../source-schain/models';

@Injectable({
  providedIn: 'root'
})
export class CreateDspService {
  public connectionType = 'rtb';
  public apiLink = '';

  public isActiveEndpoint = false;
  public isShowFields = false;
  public isFreewheelKeywordsEnabled = false;
  public freewheelKeywordsData = {
    timezone: '',
    city: '',
    dma: '',
    state: '',
    programmer_brand: '',
    channel: '',
    genre: '',
    language: '',
    content_rating: '',
    content_stream_mode: '',
  };

  public readonly FREEWHEEL_KV_MAX_PAIRS = 5;
  public freewheelKeyValuePairs: Array<{ key: string; value: string }> = [{ key: '', value: '' }];
  public isRequiredAdFormat = false;
  public isRequiredTrafficType = false;
  public isRequiredCompany = false;
  public isRequiredRegion = false;
  public isDisabledTest = false;

  public isShowVideoSizes = false;
  public isShowBannerSizes = false;

  public countriesItems: SelectItemsInterface.ICountriesItem[] = [];
  public companies: CompanyInterface.ICompany[];
  public companiesSSPDropdown: HelpersInterface.ITressSelectItem[] = [];
  public rtbVersions: { id: string; name: string }[] = [];
  public schainValues: SelectItemsInterface.ISchainValue[] = [];
  public schainNodesFilters: { id: number; name: string }[] = [];
  public schaninNodeLimitItems: { id: number; name: string }[] = [];
  public sizesList: { id: string | number, name: string }[] = [];
  public videoSizesList: { id: string | number, name: string }[] = [];
  public regions: { id: string | number, name: string }[] = [];
  public statesList: HelpersInterface.SelectItemHelper<string, string>[] = [];
  public connectionTypes: { id: number; name: string }[] = [];
  public secureOptions: { id: number, name: string }[] = [];
  public isDisableSubmit = false;
  public pornFilter: { id: number, name: string }[] = [];
  public osList: { id: string | number, name: string }[] = [];
  public listOfSizes: { id: number, width: number, height: number, name: string }[] = [];
  public serversPreBid: { id: number | string; name: string, config }[] = [];
  public serverPreBid: { name: string; field: string | number | null; id: string; config; tooltip?: string }[] = [];
  public adaptersRtb: { name: string, field: string | number | null, id: string, config, parentName?: string, tooltip?: string, disabled?: boolean }[] = [];
  public rtbAdapters: { id: number | string; name: string, config }[] = [];
  public preBidItem: PlatformInterface.IPreBidItem;
  public schainStatusItems = schainStatusItems;
  public RtbConnectionMode = RtbConnectionMode;
  public coppaFilterItems = [
    { id: 0, name: 'Only coppa=0' },
    { id: 1, name: 'Only coppa=1' },
  ];

  public schainNodeOrderItems: SelectItemsInterface.ISchainNodeOrder[] = [];

  public lmtAndDntFilterItems: HelpersInterface.SelectItemHelper<number, string>[] = [
    { id: 0, name: 'Exclude All' },
    { id: 1, name: 'Exclude LMT=1' },
    { id: 2, name: 'Exclude DNT=1' },
  ];

  public partnerSettings: PartnerInterfaceGlobal.IPartnerSettings;

  public nativeVersions = nativeVersionsItems;

  public auctionTypes = auctionTypesItems;

  public apiLinkValidationStatus = apiLinkValidationStatus;

  public endpointValidationStatusItems = endpointValidationStatusItems;

  public allowTrigger = allowTriggerItems;

  public connectionTypeEndpointLabel = connectionTypeEndpointLabelForDSP;

  public playerSizes = playerSizesItems;


  public sourceSchainItems: SourceSchainInterface.ISourceSchain[] = [];

  public pmPrebidSuspiciousIVTItems = pmPrebidSuspiciousIVTItems;

  public pmPrebidFraudIVTItems = pmPrebidFraudIVTItems;

  private requiredFields = requiredFieldsForDSP;

  private partner: PartnerInterfaceGlobal.IPartnerGeneral;
  private macrosListJs = macrosListJsDSP;
  private macrosListVast = defaultMacrosListVastDSP;
  private listOfMacros: MainDashboardInterface.IVastMacrosDSP[] = [];
  private separator: string;

  private connections = dspConnections;

  public allowCountriesTrigger = [{ id: 0, name: 'Block' }, { id: 1, name: 'Allow' }];

  private isDisabledRubiconOption = false;

  public nurlOptions: { id: number; name: string }[] = [];
  private adServers: any[] = [];
  private servers: any[] = [];
  private preBidServers: PlatformInterface.IPreBidItem[] = [];
  private preBidFields: { field: string | number, id: string, config }[] = [];
  private fields: any[] = [];
  private rtbServers: PlatformInterface.IRtbAdaptersItem[] = [];
  private adaptersItem: PlatformInterface.IRtbAdaptersItem;
  private adaptersFields: { field: string | number, id: string, config }[] = [];
  private fieldsAdapters: any[] = [];
  private value;
  private selectedServer = null;

  private sspFileCnt = 0;
  private dspFileCnt = 0;

  private marginKeys = marginKeys;
  private arrayOfMargins: { key: string, minValue: number, maxValue: number }[] = [{ key: 'margin', minValue: 0, maxValue: 100 }];
  private activeIntervals: any[] = [];

  public newDSPForm: FormGroup;

  private _isShowCustomSchain = false;
  private _isShowCustomSchainFilters = false;
  private _isShowSchainNodeOrder = false;
  private _isShowSourceFile = false;

  public endpointUrl = '';

  public region = '';

  private preparedFilter: {
    connectionType: any;
    settings: string;
  };

  private initialFormValue: { [key: string]: any } = {};

  private apiUrl: string;

  constructor(
    public appOptions: AppOptionsService,
    private auth: AuthService,
    private modalService: NzModalService,
    private dynamicFormService: DynamicFormService,
    private errorsHandlingService: ErrorsHandlingService,
    private mainService: MainService,
    private notificationService: NotificationService,
    private notificationComponent: NotificationComponent,
    private appConfig: AppConfig,
    private sourceSchainService: GeneralSchainService,
    private http: HttpClient,
  ) {
    this.apiUrl = this.appOptions.getApiUrl();
  }

  public createForm(): void {
    this.newDSPForm = this.dynamicFormService.createDSPForm();
    this.formControls['name'].addValidators([ErrorValidator.cannotContainSpace]);
    this.formControls['is_schain_complete'].disable({ emitEvent: false });
    this.formControls['is_dual_schain'].disable({ emitEvent: false });
    this.region = this.formValue.region;
    this.updateFormControlsBasedOnPartnerPlan();
    this.initialFormValue = this.newDSPForm.getRawValue();
    this.updatePchainFormControl();

    this.getCompaniesForDropdowns(this.formValue.region);
  }

  public get sChainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Contact Domain" field in Default Sellers.Json settings in the Frameworks and Regulation section'
      : 'Enabling this option activates platform processing of the schain nodes according to the Sellers.json settings.';
  }

  public get SSPSourceSchainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Contact Domain" field in Default Sellers.Json settings in the Frameworks and Regulation section'
      : `Applies Source Schain matching based on the SSP company sending the request. Only one type of Source Schain can be active at a time.
      Before activating, we recommend setting up a direct allow list with SSP endpoints linked to your file
      and applying a filter list that only allows sources included in your uploaded file`;
  }

  public get DSPSourceSchainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Contact Domain" field in Default Sellers.Json settings in the Frameworks and Regulation section'
      : `Applies Source Schain matching based on the file you select in the dropdown menu.
      Before activating, we recommend applying a filter list that only allows the sources included in your uploaded file.`;
  }

  public restrictionTooltipMessage(field: string): string {
    return (this.partner?.partner_plan !== 1 && this.partner?.partner_plan !== 2) ? `${field} is available on Plus and Enterprise versions.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public restrictionTooltipMessageForEnterprise(schainType: string): string {
    return (this.partner?.partner_plan !== 1) ? `${schainType} is available on Enterprise version.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public get isPartnerPlanBasic(): boolean {
    return this.partner?.partner_plan === 3;
  }

  public isRequiredAdapterField(itemName: string): boolean {
    const config = this.adaptersItem.config;
    return config.paramsReq[itemName]?.required ?? false;
  }

  public isRequiredPreBidField(itemName: string): boolean {
    return this.preBidItem.config.paramsReq[itemName]?.required ?? false;
  }

  public openLink(): void {
    window.open('https://smart-hub-io.atlassian.net/wiki/spaces/KBS/pages/652214275/Dual+Schain+Object+processing', '_blank');
  }

  public get videoSizeControl(): FormControl {
    return this.newDSPForm.get('playerSizes')?.get('size') as FormControl;
  }

  public get presetVideoSizeControl(): FormControl {
    return this.newDSPForm.get('presetPlayerSizes')?.get('size') as FormControl;
  }

  public initializeComponent(data: MainDashboardInterface.ICreateDspDialog): void {
    this.partner = this.auth.partner;
    this.createForm();
    this.initializeData(data);
    this.updateSizesList();
    this.getAdServers();
    this.getVastMacroses();
    if (this.isRtbConnection()) {
      this.getDSPAdapters();
    }
  }

  public isShowStatesControl(): boolean {
    const countries: string[] = this.formValue?.countriesList ?? [];
    return ['USA', 'NA'].some(code => countries.includes(code));
  }

  public isShowVastAdditionalSettings(): boolean {
    return (this.isVastConnection() || this.isJSConnection()) && this.formValue.adtype === 'inApp';
  }

  public isShowRtbAdditionalSettings(): boolean {
    return this.isRtbConnection() || this.isPreBidConnection();
  }

  public filterStatesList(query: string, option: NzSelectItemInterface) {
    if (option.nzLabel && typeof option.nzLabel === 'string') {
      if (option.nzLabel?.toLowerCase().startsWith(query.toLowerCase())) {
        return option.nzLabel?.toLowerCase().startsWith(query.toLowerCase());
      } else {
        return option.nzValue?.toLowerCase().includes(query.toLowerCase());
      }
    }

    return false;
  }

  public onChangeVideoFormatHandler(value: boolean): void {
    if (this.isVastConnection()) {
      this.onChangeVastMacrosesByFormat(value);
    }

    this.updateSizesVisibility({ video: value });
  }

  public onChangeRewardedVideoFormatHandler(value: boolean): void {
    this.onChangeVastMacrosesByFormat(value);

    this.updateSizesVisibility({ rewarded: value });
  }

  public onChangeBannerFormatHandler(value: boolean): void {
    this.updateSizesVisibility({ banner: value });
  }

  public onChangeNativeHandler(value: boolean): void {
    this.formControls['nativeSpec'].patchValue(value ? [-1] : []);

    this.updateSizesVisibility({ native: value });
  }

  public onChangeOnlyWithIFAHandler(value: boolean): void {
    if (!value) {
      this.formControls['allow_synth_ifa'].patchValue(false, { emitEvent: false });
      this.formControls['is_lmt_and_dnt_filter'].enable({ emitEvent: false });
    } else {
      this.formControls['is_lmt_and_dnt_filter'].disable({ emitEvent: false });
    }
  }

  public onChangeLMTAndDNTFilterHandler(value: boolean): void {
    if (value) {
      this.formControls['deviceIdRequired'].disable({ emitEvent: false });
    } else {
      this.formControls['deviceIdRequired'].enable({ emitEvent: false });
      this.formControls['lmt_and_dnt_filter'].patchValue(0, { emitEvent: false });
    }
  }

  public isBotmanPostBidIsEnabled() {
    return !!this.auth.partner.botman_settings?.enable_postbid;
  }

  public isHumanFraudsensorEnabled(): boolean {
    return !!this.partnerSettings.use_fraud_sensor;
  }

  public isFraudLogixEnabled(): boolean {
    return !!this.partnerSettings.useFraudlogix;
  }

  public set isShowCustomSchain(value: boolean) {
    this._isShowCustomSchain = value;
  }

  public get isShowCustomSchain(): boolean {
    return this._isShowCustomSchain;
  }

  public set isShowCustomSchainFilters(value: boolean) {
    this._isShowCustomSchainFilters = value;
  }

  public get isShowCustomSchainFilters(): boolean {
    return this._isShowCustomSchainFilters;
  }

  public set isShowSchainNodeOrder(value: boolean) {
    this._isShowSchainNodeOrder = value;
  }

  public get isShowSchainNodeOrder(): boolean {
    return this._isShowSchainNodeOrder;
  }

  public set isShowSourceFile(value: boolean) {
    this._isShowSourceFile = value;
  }

  public get isShowSourceFile(): boolean {
    return this._isShowSourceFile;
  }

  public get formControls(): { [key: string]: FormControl } {
    return this.newDSPForm.controls as { [key: string]: FormControl };
  }

  public get formValue() {
    return this.newDSPForm.getRawValue();
  }

  public get nativeSpecControl(): FormControl {
    return this.newDSPForm.get('nativeSpec') as FormControl;
  }

  public get playerSizesGroup(): FormGroup {
    return this.newDSPForm.get('playerSizes') as FormGroup;
  }

  public get presetPlayerSizesGroup(): FormGroup {
    return this.newDSPForm.get('presetPlayerSizes') as FormGroup;
  }

  public get playerSizesControls() {
    return (this.newDSPForm.get('playerSizes') as FormGroup).controls;
  }

  public get pixalatePreBidSettingsGroupValue() {
    return this.newDSPForm.get('pixalate_pb_settings')?.value;
  }

  public get pixalatePreBidSettingsControls(): { [key: string]: FormControl } {
    return (this.newDSPForm.get('pixalate_pb_settings') as FormGroup).controls as { [key: string]: FormControl };
  }

  public get jsFormControls(): { [key: string]: FormControl } {
    return (this.newDSPForm.get('js') as FormGroup).controls as { [key: string]: FormControl };
  }

  public get adtype(): string {
    return this.formControls['adtype'].value;
  }

  public onChangePixalatePreBidIpHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ip_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidIFAHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ifa_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidBundleHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('hr_app_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangeSSPSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    } else if (!value && !this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    } else if (!value && this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue.selectedAdapters !== 0) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangePlatformSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchain = value;
    this.isShowCustomSchainFilters = value;

    if (value) {
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }

    if (this.formValue.selectedAdapters !== 0) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.isShowSchainNodeOrder = this.formValue.schainCompany && this.formValue.schainCompany !== 1;

    if (!value) {
      this.isShowSchainNodeOrder = false;
      this.formControls['schain_node_order'].patchValue(1, { emitEvent: false });
      this.formControls['schainCompany'].patchValue(1, { emitEvent: false });
    }

    this.updateFormControlsBasedOnPartnerPlan();

    if (!this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    this.updatePchainFormControl();

    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeDSPSourceSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    this.isShowSourceFile = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
      this.getSourceSchainItems('dsp');
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });

      this.formControls['ipd_only'].patchValue(false, { emitEvent: false });

      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['dsp_schain_source_file_id'].patchValue(0, { emitEvent: false });
      this.sourceSchainItems = [];
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue.selectedAdapters !== 0) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    if (!this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeSSPSourceSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
      this.formControls['dsp_schain_source_file_id'].patchValue(0, { emitEvent: false });
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue.selectedAdapters !== 0) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeSchainCompanyHandler(value: number): void {

    if (value === null) {
      return;
    }

    this.isShowSchainNodeOrder = this.formValue.schainCompany && value !== 1;
    this.updateSchainNodeOrderItems(value);
  }

  public onChangeSchainNodeOrderHandler(value: number, modalWidth: string): void {
    const origin = window.location.origin;
    const notificationWidth = '400px';

    let seconds = 5;

    const schainNodeOrderItem = this.schainNodeOrderItems.find(item => item.id === value);

    if (schainNodeOrderItem?.isPresentSellerId || value === null) {
      return;
    }

    const buildMessage = (timeLeft: number): string =>
      `To activate this option, please first fill in the required Seller ID value in the Custom Schain Settings. You'll be redirected to the corresponding page in ${timeLeft} second${timeLeft === 1 ? '' : 's'}`;

    // Show notification once with initial message and store reference to the data object
    this.errorsHandlingService.showNotification('error', 'error', 'error', buildMessage(seconds), notificationWidth);
    const notificationDataRef = this.notificationComponent.data;

    const intervalId = setInterval(() => {
      seconds -= 1;
      if (seconds > 0) {
        // Update the description inside the existing notification
        if (notificationDataRef) {
          notificationDataRef.description = buildMessage(seconds);
        }
      } else {
        clearInterval(intervalId);
        // Remove interval from tracking array after it's cleared
        const index = this.activeIntervals.indexOf(intervalId);
        if (index > -1) {
          this.activeIntervals.splice(index, 1);
        }
        window.open(`${origin}/sellers-json?openSchainModal=1&modalWidth=${modalWidth}&customSchainSettings=${schainNodeOrderItem?.parentId}`, '_blank');
      }
    }, 1000);
    // Track this interval so we can clear it if needed
    this.activeIntervals.push(intervalId);
  }

  public onChangeVideoWidthPresetsHandler(value: string[]): void {
    const videoSizeControl = this.newDSPForm.get('playerSizes')?.get('size');
    const videoSizeTriggerControl = this.newDSPForm.get('playerSizes')?.get('trigger');

    if (value.length > 0) {
      videoSizeControl?.patchValue([], { emitEvent: false });
      videoSizeControl?.disable({ emitEvent: false });
      videoSizeTriggerControl?.patchValue(1, { emitEvent: false });
      videoSizeTriggerControl?.disable({ emitEvent: false });
    } else {
      videoSizeControl?.patchValue([], { emitEvent: false });
      videoSizeControl?.enable({ emitEvent: false });
      videoSizeTriggerControl?.patchValue(1, { emitEvent: false });
      videoSizeTriggerControl?.enable({ emitEvent: false });
    }
  }

  public onChangeVideoSizesHandler(value: string[]): void {
    const presetSizeControl = this.newDSPForm.get('presetPlayerSizes')?.get('size');
    const presetWidthTriggerControl = this.newDSPForm.get('presetPlayerSizes')?.get('trigger');

    if (value.length > 0) {
      presetSizeControl?.patchValue([], { emitEvent: false });
      presetSizeControl?.disable({ emitEvent: false });
      presetWidthTriggerControl?.patchValue(1, { emitEvent: false });
      presetWidthTriggerControl?.disable({ emitEvent: false });
    } else {
      presetSizeControl?.patchValue([], { emitEvent: false });
      presetSizeControl?.enable({ emitEvent: false });
      presetWidthTriggerControl?.patchValue(1, { emitEvent: false });
      presetWidthTriggerControl?.enable({ emitEvent: false });
    }
  }

  public onRtbConnectionModeChangeHandler() {
    this.formControls.rtbConnectionMode.patchValue(+this.formValue.rtbConnectionMode);
  }

  public getIsRequiredAdapterField(itemName: string): boolean {
    const config = this.adaptersItem.config;

    if (this.isConfigValid(config)) {
      return config.paramsReq[itemName]?.required ?? false;
    }

    return false;
  }

  public onChangeQPSAdapterHandler(value: boolean): void {
    if (!value) {
      this.formControls['min_rcpm'].patchValue(0);
    }
  }

  public onChangeEndpointActiveHandler(event: boolean): void {
    this.formControls['active'].patchValue(event);
  }

  public onAddSizeItemHandler(input: HTMLInputElement, array: any[]): boolean {
    const value = input.value;
    const separator = this.separator;
    const reg = /[^x0-9]+/;

    if (!this.isValidInput(value, separator, reg)) {
      this.showNotificationError('error', 'error', 'error', '', 'Size not allowed', '', '385px', 4500, 'normal');
      return false;
    }

    if (!this.isDuplicate(value, array)) {
      array.push({ id: value, name: value });
      input.value = '';
    }

    return true;
  }

  public onEnterSizeHandler(event: KeyboardEvent): void {
    if (event.code.includes('Key')) {
      this.separator = event.key;
    }
  }

  public onChangeCheckedTCFHandler(_: boolean): void {
    if (!this.formValue.useTCF) {
      this.formControls['is_only_with_consent'].patchValue(0);
    }
  }

  public onEndpointRegionChangeHandler(region: string): void {
    this.isRequiredRegion = this.formValue.region == null;
    this.getCompaniesForDropdowns(region);
  }

  public onCompanyChangeHandler(val: number): void {
    this.isRequiredCompany = this.formValue.companyId == null;

    if (val === null) {
      return;
    }

    if (val === -1) {
      this.openCompanyDialog();
    }
  }

  public onChangePreBidFieldHandler(_: Event): void {
    this.isDisableSubmit = false;
  }

  public onChangeRtbAdapterFieldHandler(_: Event, field: string | number, name: string): void {
    const fallbackTagIdItem = this.adaptersRtb.find(item => item.name === 'fallbackTagId');
    const hardcodedTagIdItem = this.adaptersRtb.find(item => item.name === 'hardcodedTagId');

    if (name === 'hardcodedTagId' && field !== '') {
      if (fallbackTagIdItem) {
        fallbackTagIdItem.disabled = true;
        fallbackTagIdItem.field = null;
      }
    } else if (name === 'hardcodedTagId' && field === '') {
      if (fallbackTagIdItem) {
        fallbackTagIdItem.disabled = false;
      }
    }


    if (name === 'fallbackTagId' && field !== '') {
      if (hardcodedTagIdItem) {
        hardcodedTagIdItem.disabled = true;
        hardcodedTagIdItem.field = null;
      }
    } else if (name === 'fallbackTagId' && field === '') {
      if (hardcodedTagIdItem) {
        hardcodedTagIdItem.disabled = false;
      }
    }

    this.isDisableSubmit = false;
  }

  public onSubmitFormHandler(callback: (type: string) => void): boolean | void {
    const connectionType = this.connections[this.connectionType];

    const countriesList = this.getSelectedCountriesList(this.formValue.countriesList);

    const isPresentStates = countriesList.includes('USA');

    if (!isPresentStates) {
      this.formControls['statesList'].patchValue([]);
      this.formControls['is_undefined_state_allowed'].patchValue(false);
    }

    this.isDisableSubmit = true;

    if (!this.handleErrors()) {
      this.isDisableSubmit = false;
      return false;
    }

    this.onCreateEndpointBaseOnConnectionType(connectionType, callback, countriesList);
  }

  public onCloseModalHandler(callback: (type: string) => void): void {
    this.sizesList = [];
    this.isRequiredTrafficType = false;
    this.isRequiredAdFormat = false;
    this.isRequiredTrafficType = false;
    this.isRequiredCompany = false;
    this.isActiveEndpoint = false;
    this.newDSPForm.reset(this.initialFormValue, { emitEvent: false });
    this.resetAdapters();
    callback('cancel');
  }

  public async onApiLinkTestHandler(link: string, e: Event): Promise<boolean> {
    e.preventDefault();
    const resp = await this.mainService.testApiLink(link);
    this.modalService.create({
      nzMaskClosable: false,
      nzContent: CompaniesTestLinkComponent,
      nzData: {
        apitest: resp,
      }
    });
    return false;
  }

  public onValidateLinkHandler(link: string, event: Event) {
    event.preventDefault();
    this.apiLink = link;
    this.isDisabledTest = false;
  }

  public onGetErrorHandler(value: boolean): void {
    this.isDisabledTest = value;
  }

  public onPreventInputHandler(event: Event, field: string): void {
    const value = this.pixalatePreBidSettingsControls[field].value;

    if (value > 100) {
      event.preventDefault();

      return this.pixalatePreBidSettingsControls[field].patchValue(parseInt(value.toString().substring(0, 2)));
    }

    if (value < 0) {
      event.preventDefault();

      return this.pixalatePreBidSettingsControls[field].patchValue(0);
    }
  }

  public isPreBidConnection(): boolean {
    return this.connectionType === 'prebid';
  }

  public isRtbConnection(): boolean {
    return this.connectionType === 'rtb';
  }

  public isVastConnection(): boolean {
    return this.connectionType === 'vast';
  }

  public isJSConnection(): boolean {
    return this.connectionType === 'js';
  }


  public onChangeConnectionTypeHandler(value: string): void {
    this.connectionType = value;
    this.onConnectionTypeChangeHandler();

    this.resetFormControls();

    if (this.isRtbConnection() || this.isVastConnection()) {
      this.formControls['endpoint'].addValidators([ErrorValidator.endpointValid]);
      this.formControls['endpoint'].addValidators([Validators.required]);
    }

    const connectionTypeActions = {
      rtb: () => this.applyRtbSettings(),
      vast: () => this.applyVastSettings(),
      prebid: () => this.applyPrebidSettings(),
      js: () => this.openJsDialog()
    };

    if (connectionTypeActions[this.connectionType]) {
      connectionTypeActions[this.connectionType]();
    }
  }

  public onChangeAdTypeHandler() {
    this.selectedServer = null;
    this.servers = [];

    this.adServers.map((item: any) => {
      if (item.adTypes[this.adtype]) {
        this.servers.push({ id: item.id, name: item.name });
      }
    });
  }

  public onChangePreBidServerHandler(server: string): void {
    if (server !== null) {
      this.preBidFields = [];
      const preBidItem = this.preBidServers.find(item => item.id === server);
      if (preBidItem) {
        this.preBidItem = preBidItem;
      }

      this.serverPreBid = this.preBidItem.fields.map(item => {
        return {
          name: item,
          field: null,
          id: item,
          config: item,
          tooltip: this.preBidItem.config.paramsReq[item]?.tooltip ?? null,
          type: this.preBidItem.config.paramsReq[item]?.type ?? 'string',
        };
      });
      if (this.serverPreBid.length > 0) {
        this.isShowFields = true;
      }
    } else {
      return;
    }
  }

  public onChangeCustomAdaptersHandler(server: string | number): void {
    if (server === null) {
      return;
    }

    if (server === 0) {
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.resetAdapters();

    const selectedServer = this.rtbServers.find(item => item.id === server);
    if (selectedServer) {
      this.adaptersItem = selectedServer;
      this.setAdaptersFields(selectedServer.fields);
    }
  }

  public onShowMacrosListHandler(macrosListContentHeight: string, macrosListBodyHeight: string): void {
    this.modalService.create({
      nzContent: MacrosListComponent,
      nzMaskClosable: false,
      nzClosable: false,
      nzClassName: 'macros-list-modal',
      nzWrapClassName: 'macros-list-modal-wrap',
      nzStyle: { top: '30px', width: '650px', height: macrosListContentHeight },
      nzBodyStyle: { width: '650px', padding: '0px', height: macrosListBodyHeight, overflowY: 'scroll' },
      nzData: {
        macrosList: this.isJSConnection() ? this.macrosListJs : this.listOfMacros,
      }
    });
    return;
  }

  public onChangeSizeHandler(id: number): void {
    if (id) {
      const elementSize = this.listOfSizes.find(element => element.id === id);
      if (elementSize) {
        this.jsFormControls['w'].patchValue(elementSize.width);
        this.jsFormControls['h'].patchValue(elementSize.height);
      }
    } else {
      this.jsFormControls['w'].patchValue(null);
      this.jsFormControls['h'].patchValue(null);
    }
  }

  public getTooltipForAdapter(name: string): string {
    return name === 'Freewheel' && !this.formValue.video
      ? 'Available with the Video ad format' :
      '';
  }

  public get isFreewheelAdapter(): boolean {
    const adapter = this.rtbAdapters.find(item => item.id === this.formValue['selectedAdapters']);
    return adapter?.name === 'Freewheel';
  }

  public onFreewheelKeywordsToggleHandler(value: boolean): void {
    this.isFreewheelKeywordsEnabled = value;
  }

  public get isFreewheelKvAtMax(): boolean {
    return this.freewheelKeyValuePairs.length >= this.FREEWHEEL_KV_MAX_PAIRS;
  }

  private normalizeFreewheelKey(key: string): string {
    return key.trim().replace(/^["']+|["']+$/g, '').trim();
  }

  public get freewheelKvDuplicateKeys(): Set<string> {
    const seen = new Set<string>();
    const duplicates = new Set<string>();
    this.freewheelKeyValuePairs.forEach(p => {
      const k = this.normalizeFreewheelKey(p.key);
      if (!k) { return; }
      if (seen.has(k)) { duplicates.add(k); } else { seen.add(k); }
    });
    return duplicates;
  }

  public addFreewheelKeyValuePair(): void {
    if (!this.isFreewheelKvAtMax) {
      this.freewheelKeyValuePairs.push({ key: '', value: '' });
    }
  }

  public removeFreewheelKeyValuePair(index: number): void {
    this.freewheelKeyValuePairs.splice(index, 1);
  }

  public getIsDisabledOption(adapterName: string): boolean {
    if (!this.partnerSettings.has_rubicon_settings && adapterName === 'Rubicon Inactive' && this.isDisabledRubiconOption) {
      return true;
    }

    if (adapterName === '33Across' && this.formValue.rtb_type !== '2.5') {
      return true;
    }

    if (adapterName === 'Freewheel' && !this.formValue.video) {
      return true;
    }

    if (adapterName === 'Tappx' && !(this.formValue.video || this.formValue.banner)) {
      return true;
    }

    return false;
  }

  public getIsDisabledPreBidOption(serverName: string): boolean {
    const requiredFormats = this.preBidServerRequiredFormats[serverName];

    if (!requiredFormats) {
      return false;
    }

    return !requiredFormats.some(format => this.formValue[format]);
  }

  public getTooltipForPreBidServer(serverName: string): string {
    const requiredFormats = this.preBidServerRequiredFormats[serverName];

    if (!requiredFormats || requiredFormats.some(format => this.formValue[format])) {
      return '';
    }

    const formatNames = requiredFormats.map(format => {
      return format.charAt(0).toUpperCase() + format.slice(1);
    });

    const formattedList = formatNames.join(' or ');

    return `Only available with the ${formattedList} Ad Formats`;
  }

  public onChangeNameHandler() {
    const nameControl = this.formControls['name'];
    if (nameControl.errors?.whitespace) {
      this.showNotificationError('error', 'error', 'error', '', 'Name cannot start with whitespace', '', '385px', 4500, 'normal');
    }
  }

  public onChangeMarginTypeHandler(_: string): void {
    this.arrayOfMargins = [];

    switch (this.formValue.margin_type) {
      case 'range':
        this.setMarginValues(undefined, undefined, undefined);
        this.setArrayOfMargins([
          { key: 'min_margin', minValue: 1, maxValue: 100 },
          { key: 'max_margin', minValue: 1, maxValue: 100 }
        ]);
        break;
      case 'fixed':
        this.setMarginValues(undefined, undefined, undefined);
        this.setArrayOfMargins([{ key: 'margin', minValue: 0, maxValue: 100 }]);
        break;
      case 'adaptive':
        this.setMarginValues(undefined, undefined, undefined);
        break;
    }
  }

  public onEndpointUrlTestHandler(endpointUrl: string, event: MouseEvent): void {
    event.preventDefault();
    this.endpointUrl = endpointUrl;
    this.region = JSON.parse(JSON.stringify(this.formValue.region));
  }

  public onShowConsentConfirmModalHandler(value: boolean): void {
    if (value) {
      const dialogRef = this.modalService.create({
        nzContent: ConsentConfirmComponent,
        nzMaskClosable: false,
        nzClosable: false,
        nzClassName: 'consent-confirm-modal',
        nzWrapClassName: 'consent-confirm-modal-wrap',
        nzStyle: { width: '650px', height: 'auto' },
        nzBodyStyle: { width: '650px', padding: '0px', height: 'auto' },
        nzCentered: true,
        nzFooter: null,
      });

      dialogRef.afterClose.subscribe((res: boolean) => {
        if (res) {
          this.formControls['is_only_with_consent'].patchValue(true, { emitEvent: false });
        } else {
          this.formControls['is_only_with_consent'].patchValue(false, { emitEvent: false });
        }
      });
    }
  }

  private resetAdapters(): void {
    this.adaptersFields = [];
    this.adaptersRtb = [];
    this.isShowFields = false;
    this.isFreewheelKeywordsEnabled = false;
    this.freewheelKeywordsData = {
      timezone: '',
      city: '',
      dma: '',
      state: '',
      programmer_brand: '',
      channel: '',
      genre: '',
      language: '',
      content_rating: '',
      content_stream_mode: '',
    };
    this.freewheelKeyValuePairs = [{ key: '', value: '' }];
  }

  private setAdaptersFields(fields: any[]): void {
    if (fields.length > 0) {
      const paramsReq = this.adaptersItem.config?.paramsReq ?? {};

      const toggleChildren = new Set<string>();
      for (const key of Object.keys(paramsReq)) {
        const param = paramsReq[key];
        if (param?.type === 'toggle' && Array.isArray(param.children)) {
          param.children.forEach((child: string) => toggleChildren.add(child));
        }
      }

      const visibleFields = fields.filter(field => {
        const param = paramsReq[field];
        return param?.type !== 'toggle' && param?.type !== 'object' && !toggleChildren.has(field);
      });

      this.adaptersRtb = visibleFields.map(field => ({
        name: field,
        field: null,
        id: field,
        config: field,
        parentName: this.adaptersItem.name,
        tooltip: paramsReq[field]?.tooltip ?? null,
        disabled: false,
      }));
    } else {
      this.adaptersRtb = [];
    }

    this.isShowFields = this.adaptersRtb.length > 0;
  }

  private updateSizesVisibility(partial?: Partial<Record<'video' | 'rewarded' | 'banner' | 'native', boolean>>): void {
    const current = this.formValue;
    const video = partial?.video ?? !!current.video;
    const rewarded = partial?.rewarded ?? !!current.rewarded;
    const banner = partial?.banner ?? !!current.banner;
    const native = partial?.native ?? !!current.native;

    const onlyNative = native && !video && !rewarded && !banner;
    const showVideoSizes = video || rewarded || onlyNative;
    const showBannerSizes = banner || native;

    this.isShowVideoSizes = showVideoSizes;
    this.isShowBannerSizes = showBannerSizes;

    // controls
    const videoSizeControl = this.newDSPForm.get('playerSizes')?.get('size');
    const videoSizeTriggerControl = this.newDSPForm.get('playerSizes')?.get('trigger');
    const presetSizeControl = this.newDSPForm.get('presetPlayerSizes')?.get('size');
    const presetWidthTriggerControl = this.newDSPForm.get('presetPlayerSizes')?.get('trigger');
    const bannerSizeControl = this.newDSPForm.get('sizesList');
    const bannerSizeTriggerControl = this.newDSPForm.get('sizeTrigger');

    if (!showVideoSizes) {
      videoSizeControl?.patchValue([], { emitEvent: false });
      videoSizeTriggerControl?.patchValue(1, { emitEvent: false });
      presetSizeControl?.patchValue([], { emitEvent: false });
      presetWidthTriggerControl?.patchValue(1, { emitEvent: false });
      videoSizeControl?.enable({ emitEvent: false });
      videoSizeTriggerControl?.enable({ emitEvent: false });
      presetSizeControl?.enable({ emitEvent: false });
      presetWidthTriggerControl?.enable({ emitEvent: false });
    }

    if (!showBannerSizes) {
      bannerSizeControl?.patchValue([], { emitEvent: false });
      bannerSizeTriggerControl?.patchValue(1, { emitEvent: false });
    }
  }

  private isValidInput(value: string, separator: string, reg: RegExp): boolean {
    const arrayString = value.split(separator);
    return (
      value.includes(separator) &&
      arrayString[0].length > 0 &&
      arrayString[1].length > 0 &&
      !reg.test(value)
    );
  }

  private isConfigValid(config: any): boolean {
    return config && !Array.isArray(config) && Object.keys(config).length > 0;
  }

  private isDuplicate(value: string, array: any[]): boolean {
    return array.some(element => element.name === value);
  }

  private openCompanyDialog(): void {
    const dialogRef = this.modalService.create({
      nzContent: CompaniesNewComponent,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: false,
      nzClassName: 'companies-new-modal',
      nzWrapClassName: 'companies-new-modal-wrap',
      nzStyle: { top: '100px', width: '650px' },
      nzBodyStyle: { width: '650px', padding: '0px', height: '335px' },
    });

    dialogRef.afterClose.subscribe((data: { status: string, data: CompanyInterface.ICompany }) => {
      if (data.status === 'success') {
        this.handleSuccessfulCompanyDialog(data.data);
      }
    });
  }

  private handleSuccessfulCompanyDialog(company: CompanyInterface.ICompany): void {
    this.companies.push(company);
    this.formControls['companyId'].patchValue(company.id);
  }

  private resetFormControls(): void {
    const controlsToReset = ['video', 'audio', 'banner', 'rewarded', 'native', 'mobileWeb', 'inApp', 'desktop', 'ctv'];
    controlsToReset.forEach(control => this.formControls[control].patchValue(false));
  }

  private applyRtbSettings(): void {
    this.formControls['useAdapter'].patchValue(true);
  }

  private applyVastSettings(): void {
    this.formControls['useAdapter'].patchValue(false);
    this.getVastMacroses();
  }

  private applyPrebidSettings(): void {
    this.formControls['selectedPreBidServer'].patchValue(null, { emitEvent: false });
    this.serverPreBid = [];
    this.isShowFields = false;
  }

  private openJsDialog(): void {
    const dialogRef = this.modalService.create({
      nzContent: JsAcceptDialogComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzCentered: true,
      nzKeyboard: false,
      nzClassName: 'js-accept-modal',
      nzWrapClassName: 'js-accept-modal-wrap',
      nzStyle: { width: '650px', height: 'auto' },
      nzBodyStyle: { width: '650px', padding: '0px', height: 'auto' },
      nzData: {
        side: 'dsp',
      }
    });

    dialogRef.afterClose.subscribe((res: { action: string }) => {
      if (res.action === 'cancel') {
        this.formControls['connectionType'].patchValue('rtb');
        this.onChangeConnectionTypeHandler('rtb');
      } else if (res.action === 'accept') {
        this.formControls['useAdapter'].patchValue(false);

        this.formControls['spendLimit'].addValidators([Validators.required]);
        this.newDSPForm.get('js')?.get('w')?.addValidators([Validators.required]);
        this.newDSPForm.get('js')?.get('h')?.addValidators([Validators.required]);
        this.newDSPForm.get('js')?.get('cpm')?.addValidators([Validators.required]);
        this.formControls['limitQPS'].addValidators([Validators.required]);

        this.isShowBannerSizes = true;
      }
    });
  }

  private setMarginValues(margin: any, minMargin: any, maxMargin: any): void {
    this.formControls['margin'].patchValue(margin);
    this.formControls['min_margin'].patchValue(minMargin);
    this.formControls['max_margin'].patchValue(maxMargin);
  }

  private setArrayOfMargins(margins: { key: string, minValue: number, maxValue: number }[]): void {
    this.arrayOfMargins = margins;
  }

  private onConnectionTypeChangeHandler() {
    this.updateCompanyFilter();
    this.fetchCompaniesByConnectionType();
    this.handlePreBidServers();
  }

  private updateCompanyFilter() {
    const connectionTypeMap = {
      rtb: 0,
      vast: 1,
      xml: 2,
      js: 3,
      prebid: 4,
    };

    const connectionTypeIndex = connectionTypeMap[this.connectionType];


    this.preparedFilter = {
      connectionType: connectionTypeIndex,
      settings: 'dsp'
    };
  }

  private getSelectedCountriesList(selectedKeys: string[]): string[] {
    const regionResolvers: Record<string, () => string[]> = {
      Caribbean: () => this.appOptions.getCaribbeanCountriesKeysList(),
      NA: () => this.appOptions.getNorthAmericaCountriesKeysList(),
      LATAM: () => [
        ...this.appOptions.getLATAMCountriesKeysList(),
        ...this.appOptions.getCaribbeanCountriesKeysList(),
      ],
      EU: () => this.appOptions.getEuropeCountriesKeysList(),
      MENA: () => this.appOptions.getMENACountriesKeysList(),
      SSA: () => this.appOptions.getSSACountriesKeysList(),
      APAC: () => this.appOptions.getAPACCountriesKeysList(),
      Other: () => this.appOptions.getOtherCountriesKeysList(),
    };

    const result = new Set<string>(selectedKeys);

    Object.entries(regionResolvers).forEach(([shortcut, resolver]) => {
      const shortcutSelected = result.has(shortcut);
      const countries = resolver();

      if (shortcutSelected) {
        // Add all countries from the shortcut and remove the shortcut itself.
        countries.forEach(code => result.add(code));
        result.delete(shortcut);
      }
    });

    return Array.from(result);
  }

  private addMaxLengthError(errors: string[], maxLengthError: { requiredLength: number; actualLength: number }): void {
    errors.push(`You have reached your maximum limit of characters allowed. Required length is ${maxLengthError.requiredLength}, but you entered ${maxLengthError.actualLength}`);
  }

  private addRequiredError(errors: string[]): void {
    errors.push('Name is required');
  }

  private checkTotalSpendLimit(requiredFields: any): void {
    if (this.formValue.useTotalSpendLimit) {
      requiredFields.totalSpendLimit = 'Total spend limit';
      this.formControls['totalSpendLimit'].markAsTouched();
    }
  }

  private checkRequiredFields(requiredFields: any, errorMessages: string[]): void {
    for (const field in requiredFields) {
      if (this.formControls[field]?.status === 'INVALID' && requiredFields[field]) {
        errorMessages.push(`${requiredFields[field]} is required`);
      }
    }
  }

  private checkPreBidServer(errorMessages: string[]): void {
    if (this.isPreBidConnection() && this.formControls.selectedPreBidServer.errors?.required) {
      errorMessages.push('Prebid Server is required');
    }
  }

  private checkCustomValidations(errorMessages: string[]): void {
    errorMessages = this.validateDefaultPriceVast(errorMessages);
    errorMessages = this.validateEndpointIfSetAdServer(errorMessages);
    errorMessages = this.validateTrafficType(errorMessages);
    errorMessages = this.validateAdFormat(errorMessages);
    errorMessages = this.validateCompany(errorMessages);
    errorMessages = this.validateRegion(errorMessages);
    errorMessages = this.validatePreBidServer(errorMessages);
    errorMessages = this.validateJsCPM(errorMessages);
    errorMessages = this.validateJsHeight(errorMessages);
    errorMessages = this.validateJsWidth(errorMessages);
    errorMessages = this.validateSpendLimit(errorMessages);
    errorMessages = this.validateMargin(errorMessages, this.arrayOfMargins);
    errorMessages = this.validateName(errorMessages);
    errorMessages = this.checkPmPrebidIVT(errorMessages);
    errorMessages = this.validateSchainSourceFileChecked(errorMessages);

    if (this.isRtbConnection()) {
      errorMessages = this.checkEndpointURL(errorMessages);
    }

    if (this.isFreewheelAdapter && this.isFreewheelKeywordsEnabled && this.freewheelKvDuplicateKeys.size > 0) {
      const keys = Array.from(this.freewheelKvDuplicateKeys).join(', ');
      errorMessages.push(`Custom Key-Value Pair contains duplicate keys: ${keys}`);
    }
  }

  private displayErrorMessages(errorMessages: string[]): void {
    errorMessages.forEach(errorMessage => {
      this.showNotificationError('error', 'error', 'error', '', errorMessage, '', '385px', 4500, 'normal');
    });
  }

  private checkEndpointURL(errorMessages: string[]): string[] {
    const endpointControl = this.formControls['endpoint'];

    if (endpointControl.errors?.required) {
      errorMessages.push('Endpoint is required');
    }

    if (endpointControl.errors?.invalidEndpoint) {
      errorMessages.push('Endpoint must be a valid URL');
    }

    return errorMessages;
  }

  private checkPmPrebidIVT(errorMessages: string[]): string[] {
    if (this.partnerSettings.usePMPreBid && this.formControls['pmPrebidSuspiciousIVT']?.value && this.formControls['pmPrebidFraudIVT']?.value) {
      const suspiciousIVT = this.formControls['pmPrebidSuspiciousIVT'].value;
      const fraudIVT = this.formControls['pmPrebidFraudIVT'].value;

      this.formControls['pmPrebidSuspiciousIVT'].markAsTouched();
      this.formControls['pmPrebidFraudIVT'].markAsTouched();

      if (!/^[1-9]$|^[1-9][0-9]$|^(100)$/.test(suspiciousIVT)) {
        errorMessages.push('Public Media Suspicions IVT must be between 0 and 100');
      }

      if (!/^[1-9]$|^[1-9][0-9]$|^(100)$/.test(fraudIVT)) {
        errorMessages.push('Public Media Fraud IVT must be between 0 and 100');
      }
    }

    return errorMessages;
  }

  private validateDefaultPriceVast(errors: string[]): string[] {
    const defaultPriceVastControl = this.formControls['defaultPriceVast'];

    if (this.connectionType === 'vast') {
      defaultPriceVastControl.markAsTouched();
      const value = defaultPriceVastControl.value;

      if (defaultPriceVastControl.errors?.required) {
        errors.push('Fixed Price is required');
      }

      if (value && !/^([0-9]*[.])?[0-9]+$/.test(value)) {
        errors.push('Fixed Price must be an integer.');
        defaultPriceVastControl.setErrors({ 'incorrect': true });
      }

      if (value <= 0) {
        errors.push('Fixed Price must be greater than 0.');
        defaultPriceVastControl.setErrors({ 'incorrect': true });
      }

      if (defaultPriceVastControl.status === 'INVALID') {
        errors.push('Fixed Price is required');
      } else {
      }
    }

    return errors;
  }

  private validateEndpointIfSetAdServer(errors: string[]): string[] {
    if (this.connectionType === 'vast' && this.selectedServer != null) {
      const adServer: any = this.adServers.find((item: any) => item.adTypes[this.adtype] && item.id === this.selectedServer);

      if (adServer) {
        const url = adServer.adTypeUrls[this.adtype]?.url;
        const endpointValue = this.formControls['endpoint'].value;

        if (endpointValue && endpointValue.length > 0 && !endpointValue.includes(url)) {
          errors.push('Endpoint must consist of URL from VAST Template');
        }
      }
    }

    return errors;
  }

  private validateCompany(errors: string[]): string[] {
    this.isRequiredCompany = !this.formValue.companyId;

    if (this.isRequiredCompany) {
      errors.push('Company is required');
    }

    return errors;
  }

  private validateRegion(errors: string[]): string[] {
    this.isRequiredRegion = !this.formValue.region;

    if (this.isRequiredRegion) {
      errors.push('Region is required');
    }

    return errors;
  }

  private validateTrafficType(errors: string[]): string[] {
    if (this.isRtbConnection() || this.isPreBidConnection()) {
      this.validateRtbOrPreBidConnection(errors);
    } else if (this.isVastConnection()) {
      this.validateVastConnection(errors);
    }

    return errors;
  }

  private validateRtbOrPreBidConnection(errors: string[]): void {
    const checkedAtLeastOneType = this.formValue.mobileWeb || this.formValue.desktop || this.formValue.inApp || this.formValue.ctv;
    this.isRequiredTrafficType = !checkedAtLeastOneType;

    if (this.isRequiredTrafficType) {
      errors.push('Please select at least one traffic type.');
    }
  }

  private validateVastConnection(errors: string[]): void {
    const checkedAtLeastOneType = this.adtype === 'mobileWeb' || this.adtype === 'inApp' || this.adtype === 'desktop' || this.adtype === 'ctv';
    this.isRequiredTrafficType = !checkedAtLeastOneType;

    if (this.isRequiredTrafficType) {
      errors.push('Please select at least one traffic type.');
    }
  }

  private validateJsCPM(errors: string[]): string[] {
    if (!this.formValue.js.cpm && this.isJSConnection()) {
      errors.push('Fixed CPM is required');
      this.formControls['js']?.get('cpm')?.setErrors({ invalid: true });
      this.formControls['js']?.get('cpm')?.markAsTouched();
    }
    return errors;
  }

  private validateJsHeight(errors: string[]): string[] {
    if (!this.formValue.js.h && this.isJSConnection()) {
      errors.push('Height is required');
      this.newDSPForm.get('js')?.get('h')?.setErrors({ invalid: true });
      this.newDSPForm.get('js')?.get('h')?.markAsTouched();
    }
    return errors;
  }

  private validateJsWidth(errors: string[]): string[] {
    if (!this.formValue.js.w && this.isJSConnection()) {
      errors.push('Width is required');
      this.newDSPForm.get('js')?.get('w')?.setErrors({ invalid: true });
      this.newDSPForm.get('js')?.get('w')?.markAsTouched();
    }
    return errors;
  }

  private validateSpendLimit(errors: string[]): string[] {
    if (!this.formValue.spendLimit && this.isJSConnection()) {
      errors.push('Spend Limit is required');
    }
    return errors;
  }

  private validateAdFormat(errors: string[]): string[] {
    if (this.isRelevantConnection()) {
      this.checkAdFormats(errors);
    }

    return errors;
  }

  private checkAdFormats(errors: string[]): void {
    const checkedAtLeastOneFormat = this.formValue.banner ||
      this.formValue.native || this.formValue.video || this.formValue.pop ||
      this.formValue.push || this.formValue.rewarded || this.formValue.audio;

    this.isRequiredAdFormat = !checkedAtLeastOneFormat;

    if (this.isRequiredAdFormat) {
      errors.push('Please select at least one ad format.');
    }
  }

  private validatePreBidServer(errors: string[]): string[] {
    if (this.isPreBidConnection() && this.formValue.selectedPreBidServer === null) {
      errors.push('Please select Prebid server to proceed with the creation of the Prebid endpoint');
    }

    return errors;
  }

  private validateMargin(errors: string[], arrayOfMargins: { key: string, minValue: number, maxValue: number }[]): string[] {
    if (this.isRangeMarginType()) {
      this.validateRangeMargins(errors);
    }

    arrayOfMargins.forEach(margin => {
      this.validateMarginValue(errors, margin);
    });

    return errors;
  }

  private validateRangeMargins(errors: string[]): void {
    const { min_margin, max_margin } = this.formValue;
    if (min_margin >= max_margin && (min_margin !== null && max_margin !== null)) {
      this.formControls['min_margin'].setErrors({ invalid: true });
      this.formControls['max_margin'].setErrors({ invalid: true });
      errors.push('Maximum margin value must be greater than minimum margin value');
    }
  }

  private validateMarginValue(errors: string[], margin: { key: string, minValue: number, maxValue: number }): void {
    const value = this.formValue[margin.key];
    const marginKey = this.marginKeys[margin.key];

    if (value < margin.minValue) {
      errors.push(`${marginKey} value must not be lower than ${margin.minValue}`);
    }

    if (value > margin.maxValue) {
      errors.push(`${marginKey} value must not be higher than ${margin.maxValue}`);
    }

    if (value === null || value === undefined) {
      errors.push(`${marginKey} is required`);
    }
  }

  private validateSchainSourceFileChecked(errors: string[]): string[] {
    if (this.formValue.schain_source && this.formControls['dsp_schain_source_file_id'].errors?.required) {
      errors.push('Please select the Source Schain File');
    }

    return errors;
  }

  private validateName(errors: string[]): string[] {
    const nameControl = this.newDSPForm.controls['name'];
    const maxLengthError = nameControl.errors?.maxlength;
    const requiredError = nameControl.errors?.required;

    if (maxLengthError) {
      nameControl.markAsTouched();
      this.addMaxLengthError(errors, maxLengthError);
    }

    if (requiredError) {
      nameControl.markAsTouched();
      this.addRequiredError(errors);
    }

    return errors;
  }

  private showNotificationError(
    iconType: string,
    color: string,
    notificationType: string,
    leftPartOfText: string,
    description: string,
    rightPartOfText: string,
    width: string,
    duration: number,
    fontWeight: string,
  ): void {
    const data = {
      iconType,
      color,
      notificationType,
      description,
      leftPartOfText: leftPartOfText ?? '',
      rightPartOfText: rightPartOfText ?? '',
      fontWeight: fontWeight ?? 'normal'
    };
    this.notificationComponent.data = data;
    this.notificationService.showTemplate({
      nzData: data,
      nzStyle: { width: width ?? '385px' },
      nzDuration: duration ?? 4500,
    });
  }

  private handleErrors(): boolean {
    this.markControlsAsTouched();
    const errorMessages = this.collectErrorMessages();

    if (errorMessages.length) {
      this.displayErrorMessages(errorMessages);
      return false;
    }

    return true;
  }

  private markControlsAsTouched(): void {
    const controlsToMark = [
      { condition: this.isRtbConnection() || this.isVastConnection(), controls: ['region', 'companyId', 'endpoint', 'limitQPS'] },
      { condition: this.isPreBidConnection(), controls: ['region', 'companyId', 'limitQPS', 'selectedPreBidServer'] },
      { condition: this.isJSConnection(), controls: ['region', 'companyId', 'limitQPS', 'spendLimit'] }
    ];

    controlsToMark.forEach(({ condition, controls }) => {
      if (condition) {
        controls.forEach(control => this.formControls[control]?.markAsTouched());
      }
    });

    if (this.formControls['newCompanyName']) {
      this.formControls['newCompanyName'].markAsTouched();
    }

    if (this.formValue.margin_type === 'fixed') {
      this.formControls['margin'].markAsTouched();
    }

    if (this.formValue.margin_type === 'range') {
      this.formControls['min_margin'].markAsTouched();
      this.formControls['max_margin'].markAsTouched();
    }
  }

  private collectErrorMessages(): string[] {
    const errorMessages: string[] = [];
    const requiredFields = this.requiredFields;

    this.checkTotalSpendLimit(requiredFields);
    this.checkPreBidServer(errorMessages);
    this.checkRequiredFields(requiredFields, errorMessages);
    this.checkCustomValidations(errorMessages);

    return errorMessages;
  }

  private isRelevantConnection(): boolean {
    return this.isRtbConnection() || this.isPreBidConnection() || this.isVastConnection();
  }

  private isRangeMarginType(): boolean {
    return this.formValue.margin_type === 'range';
  }

  private readonly preBidServerRequiredFormats: Record<string, Array<'banner' | 'native' | 'video'>> = {
    'Streamlyn-Prebid': ['banner', 'native', 'video'],
    'Insticator-Prebid': ['banner', 'video'],
    'Online Media Solutions-Prebid': ['banner', 'video'],
    'Index Exchange-Prebid': ['banner', 'native', 'video'],
    'Rise-Prebid': ['banner', 'native', 'video'],
    'Vidazoo-Prebid': ['banner', 'video'],
    'AdMatic GMBH-Prebid': ['banner', 'native', 'video'],
    'Afront-Prebid': ['banner', 'native', 'video'],
    'AMX-Prebid': ['banner', 'video'],
    'Seedtag-Prebid': ['banner', 'video'],
    'Microsoft-Prebid': ['banner', 'native', 'video'],
  };

  private handleAdapterResponse(res: any): void {
    const fieldsNone = {
      name: 'None',
      id: 0,
      fields: [],
      config: {},
    };

    this.rtbServers = res;
    this.rtbServers.unshift(fieldsNone);
    this.rtbServers.forEach(item => this.processServerItem(item));
  }

  private processServerItem(item: any): void {
    if (item.name === 'Rubicon' && !this.partnerSettings.has_rubicon_settings) {
      item.name = 'Rubicon Inactive';
    }

    if (item.name === 'CustomExtensions') {
      item.name = 'Custom Extensions';
    }
    this.rtbAdapters = this.rtbServers.map(({ id, name, config }) => ({ id, name, config }));
  }

  private populateAdaptersFields(): void {
    this.adaptersRtb.forEach(item => {
      this.adaptersFields.push({ field: item.field as string, id: item.id, config: item.config });
    });
  }

  private validateAdapterFields(): boolean {
    let isValid = true;
    for (const field of this.adaptersFields) {
      if (this.adaptersItem.config.length && this.adaptersItem.config.paramsReq[field.id]?.required && (!field.field || (field.field as string).length === 0)) {
        this.showNotificationError('error', 'error', 'error', '', `${field.id} is required`, '', '385px', 4500, 'normal');
        this.isDisableSubmit = true;
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  private buildAdapterConfig(): any {
    const fields: any = {};
    this.fieldsAdapters = [];

    this.adaptersFields.forEach(value => {
      fields[value.id] = value.field;
    });

    if (this.isFreewheelAdapter) {
      fields['_indicateToggle'] = this.isFreewheelKeywordsEnabled ? 1 : 0;

      if (this.isFreewheelKeywordsEnabled) {
        const d = this.freewheelKeywordsData;
        fields['timezone'] = d.timezone || null;
        fields['city'] = d.city || null;
        fields['dma'] = d.dma || null;
        fields['state'] = d.state || null;
        fields['programmerBrand'] = d.programmer_brand || null;
        fields['channel'] = d.channel || null;
        fields['genre'] = d.genre || null;
        fields['language'] = d.language || null;
        fields['contentRating'] = d.content_rating || null;
        fields['contentStreamMode'] = d.content_stream_mode || null;

        const validPairs = this.freewheelKeyValuePairs.filter(p => p.key.trim());
        if (validPairs.length > 0) {
          const customObj: Record<string, string> = {};
          validPairs.forEach(p => {
            customObj[this.normalizeFreewheelKey(p.key)] = p.value;
          });
          fields['custom'] = customObj;
        }
      }
    }

    this.fieldsAdapters.push(fields);
    return fields;
  }

  private openEndpointLinkDialog(endpoint: string, name: string): void {
    this.sizesList = [];
    this.modalService.create({
      nzContent: EndpointLinkDialogComponent,
      nzMaskClosable: false,
      nzClassName: 'endpoint-link-modal',
      nzWrapClassName: 'endpoint-link-modal-wrap',
      nzStyle: { top: '100px', width: '600px', height: 'auto' },
      nzBodyStyle: { width: '600px', padding: '0px', height: 'auto' },
      nzClosable: false,
      nzData: { endpoint, name }
    });
  }

  private resetVastFormControls(): void {
    this.isDisableSubmit = false;
    this.formControls['ctv'].patchValue(this.adtype === 'ctv');
    this.formControls['mobileWeb'].patchValue(this.adtype === 'mobileWeb');
    this.formControls['desktop'].patchValue(this.adtype === 'desktop');
    this.formControls['inApp'].patchValue(this.adtype === 'inApp');
  }

  private setConnectionModeValues(): void {
    // Any specific values or settings related to connection mode can be set here
  }

  private handleCreateVastSuccess(resp: PlatformInterface.IUpdateDSPResponse, callback: (type: string) => void): void {
    callback('created');
    this.isActiveEndpoint = false;
    this.newDSPForm.reset({}, { emitEvent: false });
    this.connectionType = 'rtb';
    this.sizesList = [];
    this.openEndpointLinkDialog(resp.data.endpoint, resp.data.name);
  }

  private mapPreBidFields(): void {
    this.serverPreBid.map(item => {
      this.preBidFields.push({ field: item.field as string, id: item.id, config: item.config });
    });

    const fields = {};
    this.preBidFields.forEach(value => {
      fields[value.id] = value.field;
    });
    this.fields.push(fields);
  }

  private validateFields(fields: any): boolean {
    for (const field in fields) {
      if (this.preBidItem.config && this.preBidItem.config.paramsReq[field].required && (!fields[field] || fields[field].length === 0)) {
        this.showNotificationError('error', 'error', 'error', '', `${field} is required`, '', '385px', 4500, 'normal');
        this.isDisableSubmit = true;
        return false;
      }
    }
    this.isDisableSubmit = !this.value;
    return true;
  }

  private cleanFormValue(): void {
    if (!this.formValue.useAdapter) {
      delete this.formValue.min_rcpm;
    }
    delete this.formValue.rtbConnectionMode;
    delete this.formValue.vastConnectionMode;
  }

  private preparePreBidData(fields: any, connectionType: number, countriesList: string[]): any {
    return this.fields.length > 0 ? {
      ...this.formValue,
      adapter_id: this.formValue['selectedPreBidServer'],
      adapter_config: fields,
      connectionType: connectionType,
      nativeSpec: this.formValue['nativeSpec'].includes(-1) ? [1, 2, 3] : this.formValue['nativeSpec'],
      endpoint: '',
      sspList: this.getModifiedSSPList(),
      countriesList,
    } : {
      ...this.formValue,
      adapter_id: this.formValue['selectedPreBidServer'],
      adapter_config: null,
      connectionType: connectionType,
      nativeSpec: this.formValue['nativeSpec'].includes(-1) ? [1, 2, 3] : this.formValue['nativeSpec'],
      endpoint: '',
      sspList: this.getModifiedSSPList(),
      countriesList,
    };
  }

  private handleApiResponse(callback: (type: string) => void): (resp: PlatformInterface.IUpdateDSPResponse) => void {
    return (resp: PlatformInterface.IUpdateDSPResponse) => {
      callback('created');
      this.isActiveEndpoint = false;
      this.newDSPForm.reset({}, { emitEvent: false });
      this.connectionType = 'rtb';
      this.sizesList = [];
      this.openEndpointLinkDialog(resp.data.endpoint, resp.data.name);
    };
  }

  private modifyReqData(removedFields: string[], checkboxes: string[], reqObject: { [key: string]: any }): { [key: string]: any } {
    let requestBody: { [key: string]: any } = {};
    for (const key of Object.keys(reqObject)) {
      if (key !== 'adapter_config') {
        if (removedFields.includes(key) || reqObject[key] === null || reqObject[key] === undefined) {
          delete reqObject[key];
          continue;
        }
      }

      if (checkboxes.includes(key)) {
        reqObject[key] = reqObject[key] ? 1 : 0;
        continue;
      }

      if (key === 'pixalate_pb_settings' && typeof reqObject[key] === 'object') {
        for (const innerKey of Object.keys(reqObject[key])) {
          if (checkboxes.includes(innerKey)) {
            const innerValue = reqObject[key][innerKey];
            reqObject[key][innerKey] = innerValue ? 1 : 0;
          }
        }
      }
    }

    requestBody = { ...reqObject };

    return requestBody;
  }

  private getModifiedSSPList(): number[] {
    const array = getEndpointsCheckedKeys(this.companiesSSPDropdown);
    const modifiedSSPList = [...array];

    return modifiedSSPList;
  }

  private getSchainFilterItems(): void {
    this.mainService.getFilterValuesByKeyReq({ filters: ['schainNodesFilter', 'schainValues'] })
      .subscribe((res: { schainNodesFilter: { id: number; name: string }[], schainValues: SelectItemsInterface.ISchainValue[] }) => {
        this.schainNodesFilters = res.schainNodesFilter;
        this.schainValues = res.schainValues;
      }, error => this.errorsHandlingService.handleError(error));
  }

  private initializeData(data: MainDashboardInterface.ICreateDspDialog): void {
    this.setBasicSettings(data);
    this.setSchainData(data);
    this.setListsData(data);
    this.getSchainFilterItems();
    this.connectionType = 'rtb';
    this.isRequiredCompany = false;
    this.isRequiredRegion = false;
    this.isRequiredAdFormat = false;
    this.isRequiredTrafficType = false;
    this.isDisabledTest = false;
    this.endpointUrl = '';
    this.apiLink = '';
  }

  private setBasicSettings(data: MainDashboardInterface.ICreateDspDialog): void {
    this.partnerSettings = data.partnerSettings;
    if (!this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.partnerSettings.is_source_schain) {
      this.getExistingSourceSchainInfo();
    } else {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (!this.partnerSettings.is_authorized_schain) {
      this.formControls['is_authorized_schain'].disable({ emitEvent: false });
    } else {
      this.updateIsAuthorizedSchainControlState();
    }
  }

  private setSchainData(data: MainDashboardInterface.ICreateDspDialog): void {
    this.schaninNodeLimitItems = data.schaninNodeLimitItems;
  }

  private setListsData(data: MainDashboardInterface.ICreateDspDialog): void {
    this.connectionTypes = data.connectionTypes ? [...data.connectionTypes] : [];
    this.osList = data.osList ? [...data.osList] : [];
    this.sizesList = [...data.sizesList];
    this.rtbVersions = data.rtbVersions ? [...data.rtbVersions] : [];
    this.pornFilter = data.pornFilter ? [...data.pornFilter] : [];
    this.secureOptions = data.secureOptions ? [...data.secureOptions] : [];
    this.nurlOptions = data.nurlOptions ? [...data.nurlOptions] : [];
    this.listOfSizes = data.listOfSizes ? [...data.listOfSizes] : [];
    this.companies = data.allCompanies ? [...data.allCompanies] : [];
    this.statesList = data.statesList ? [...data.statesList] : [];
    this.countriesItems = data.countriesItems ? [...data.countriesItems] : [];

    this.videoSizesList = this.appOptions.getVideoSizesList();

    this.regions = this.appOptions.getRegions(this.auth.partner.regions);
  }

  private updateSizesList(): void {
    const PARTNER_23 = 23;
    const PARTNER_10 = 10;

    switch (this.partner.id) {
      case PARTNER_23:
        this.sizesList.push({ id: '768x1024', name: '768x1024' });
        break;
      case PARTNER_10:
        this.sizesList.push(
          { id: '350x196', name: '350x196' },
          { id: '768x1024', name: '768x1024' },
          { id: '728x1280', name: '728x1280' },
        );
        break;
    }
  }

  private updateSchainNodeOrderItems(companyId: number): void {
    const defaultItems: SelectItemsInterface.ISchainNodeOrder[] = [
      { id: 1, name: 'Default order', isPresentSellerId: true, parentId: 0 }
    ];

    const customNode = this.schainValues.find(item => item.id === companyId);

    if (!customNode || companyId === 1) {
      this.schainNodeOrderItems = defaultItems;
      return;
    }

    const schainNodeOrderItems = [
      ...defaultItems,
      { id: 2, name: `Default + ${customNode.sellerName}`, isPresentSellerId: customNode.defaultCustomSellerId ? true : false, parentId: customNode.id },
      { id: 3, name: `${customNode.sellerName} + Default`, isPresentSellerId: customNode.customDefaultSellerId ? true : false, parentId: customNode.id },
    ];

    this.schainNodeOrderItems = schainNodeOrderItems;
    this.appConfig.schainNodeOrderItems$.next(schainNodeOrderItems);
  }

  private updateFormControlsBasedOnPartnerPlan(): void {
    if (this.partner?.partner_plan !== 1 && this.partner?.partner_plan !== 2) {
      this.formControls['schain_filter_option'].disable({ emitEvent: false });
      this.formControls['schain_complete_option'].disable({ emitEvent: false });
      this.formControls['schain_limit'].disable({ emitEvent: false });
    } else if (this.partner?.partner_plan === 1 || this.partner?.partner_plan === 2) {
      this.formControls['schain_filter_option'].enable({ emitEvent: false });
      this.formControls['schain_complete_option'].enable({ emitEvent: false });
      this.formControls['schain_limit'].enable({ emitEvent: false });
    }

    if (this.partner?.partner_plan !== 1) {
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['schainCompany'].disable({ emitEvent: false });
      this.formControls['is_requests_empty_appname'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    } else {
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['schainCompany'].enable({ emitEvent: false });
      this.formControls['is_requests_empty_appname'].enable({ emitEvent: false });


      if (this.formValue['sChain']) {
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    this.updateIsAuthorizedSchainControlState();
  }

  private updateIsAuthorizedSchainControlState(): void {
    if (!this.formControls['is_authorized_schain']) {
      return;
    }

    if (!this.formValue['sChain']) {
      this.formControls['is_authorized_schain'].patchValue(false, { emitEvent: false });
      this.formControls['is_authorized_schain'].disable({ emitEvent: false });
    } else {
      if (this.partnerSettings?.is_authorized_schain) {
        this.formControls['is_authorized_schain'].enable({ emitEvent: false });
      } else {
        this.formControls['is_authorized_schain'].disable({ emitEvent: false });
      }
    }
  }

  private updatePchainFormControl(): void {
    if (this.formValue.isSspSchain || this.formValue.sChain || this.formValue.is_ssp_schain_source || this.formValue.schain_source) {
      this.formControls['is_pchain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_pchain'].disable({ emitEvent: false });
      this.formControls['is_pchain'].patchValue(false, { emitEvent: false });
    }
  }

  private getVastMacroses(): void {
    this.listOfMacros = [];
    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.listOfMacros.push(
      {
        id: '[IP]',
        name: '[IP]',
        mobileWeb: false,
        desktop: false,
        inApp: false,
        ctv: false,
        desc: 'IPv4 address closest to device',
      },
    );
    this.listOfMacros.push(
      {
        id: '[UA]',
        name: '[UA]',
        mobileWeb: false,
        desktop: false,
        inApp: false,
        ctv: false,
        desc: 'Browser user agent string.',
      },
    );
  }

  private onChangeVastMacrosesByFormat(value: boolean): void {
    if (value) {
      this.macrosListVast = this.macrosListVast.filter(item => item.id !== '[FEED]');
    } else {
      this.macrosListVast = defaultMacrosListVastDSP;
    }
    this.listOfMacros = this.macrosListVast.map(macros => macros);
  }

  private handleError(error: any, connectionType: any, callback: (type: string) => void): void {
    if (error.errors.global.hasOwnProperty('has_rubicon_settings') && error.errors.global.has_rubicon_settings.includes(false)) {
      this.showNotificationError(
        'error',
        'error',
        'adapter-error',
        'Credentials are required for Rubicon API adapter setup. Please fill in Rubicon credentials in the',
        'Platform settings ',
        'section first, then you will be able to create an endpoint with Rubicon API adapter configuration.',
        '450px',
        10000,
        'bold',
      );
    } else {
      const validationErrorsIP = 'IP tied to EP URL couldn’t be found. Do you want to proceed creating endpoint?';
      const validationErrorsRegionNotFound = 'The region which IP tied to EP URL could not be found';
      const validationErrorsRegion = 'This endpoint is tied to IP in';

      if (error.code === 422 &&
        (
          error.messages[0].includes(validationErrorsIP) ||
          error.messages[0].includes(validationErrorsRegionNotFound) ||
          error.messages[0].includes(validationErrorsRegion)
        )
      ) {
        this.openValidationModal(error.messages[0], connectionType, callback);
      } else {
        this.errorsHandlingService.handleError(error);
      }
    }
  }

  private openValidationModal(message: string, connectionType: any, callback: (type: string) => void): void {
    const dialogRef = this.modalService.create({
      nzContent: ValidationEndpointModalComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzCentered: true,
      nzKeyboard: false,
      nzStyle: { width: '500px', height: 'auto' },
      nzBodyStyle: { width: '500px', padding: '0px', height: 'auto' },
      nzData: {
        message: message,
      }
    });


    dialogRef.afterClose.subscribe(res => {
      if (res) {
        const countriesList = this.getSelectedCountriesList(this.formValue.countriesList);
        this.onCreateEndpointBaseOnConnectionType(connectionType, callback, countriesList, 1);
      } else {
        this.isDisableSubmit = false;
        return;
      }
    });
  }

  private createRTB(connectionType: number, callback: (type: string) => void, countriesList: string[], accept?: number): void {
    if (!this.formValue.useAdapter) {
      delete this.formValue.min_rcpm;
    }

    this.populateAdaptersFields();

    if (this.adaptersFields.length > 0 && !this.validateAdapterFields()) {
      return;
    }

    delete this.formValue.vastConnectionMode;

    const rtbData = {
      ...this.formValue,
      connectorType: connectionType,
      adapter_id: this.formValue['selectedAdapters'],
      adapter_config: this.adaptersFields.length > 0 ? this.buildAdapterConfig() : null,
      connectionType: 0,
      nativeSpec: this.formValue['nativeSpec'].includes(-1) ? [1, 2, 3] : this.formValue['nativeSpec'],
      sspList: this.getModifiedSSPList(),
      accept: accept ?? undefined,
      countriesList,
    };

    this.mainService.createNewDSP(this.modifyReqData(removedRtbDSPFields, rtbDSPCheckboxes, rtbData))
      .pipe(finalize(() => this.isDisableSubmit = false))
      .subscribe(
        (resp: PlatformInterface.IUpdateDSPResponse) => {
          callback('created');
          this.isActiveEndpoint = false;
          this.newDSPForm.reset({}, { emitEvent: false });
          this.connectionType = 'rtb';
          this.openEndpointLinkDialog(resp.data.endpoint, resp.data.name);
          this.resetAdapters();
        },
        error => {
          this.isDisableSubmit = false;
          this.handleError(error, connectionType, callback);
        }
      );
  }

  private createVast(connectionType: number, callback: (type: string) => void, countriesList: string[], accept?: number): void {
    this.resetVastFormControls();
    this.setConnectionModeValues();

    if (this.formValue['defaultPriceVast']) {
      this.formControls['auctionType'].patchValue(1);
    }

    delete this.formValue.min_rcpm;
    delete this.formValue.rtbConnectionMode;

    const vastData = {
      ...this.formValue,
      nativeSpec: this.formValue['nativeSpec'].includes(-1) ? [1, 2, 3] : this.formValue['nativeSpec'],
      sspList: this.getModifiedSSPList(),
      connectionType,
      countriesList,
      accept: accept ?? undefined,
    };

    this.mainService.createNewDSP(this.modifyReqData(removedVastDSPFields, vastDSPCheckboxes, vastData))
      .pipe(finalize(() => this.isDisableSubmit = false))
      .subscribe(
        (resp: PlatformInterface.IUpdateDSPResponse) => {
          this.handleCreateVastSuccess(resp, callback);
        },
        error => {
          this.handleError(error, connectionType, callback);
        }
      );
  }

  private createPreBid(connectionType: number, callback: (type: string) => void, countriesList: string[], accept?: number): void {
    this.mapPreBidFields();
    const fields = this.fields[this.fields.length - 1];

    if (!this.validateFields(fields)) return;

    this.cleanFormValue();
    const preBidData = this.preparePreBidData(fields, connectionType, countriesList);

    if (accept) {
      preBidData.accept = accept;
    }

    this.mainService.createNewDSP(this.modifyReqData(removedPreBidDSPFields, preBidDSPCheckboxes, preBidData))
      .pipe(finalize(() => this.isDisableSubmit = false))
      .subscribe(this.handleApiResponse(callback),
        error => {
          this.isDisableSubmit = false;
          this.handleError(error, connectionType, callback);
        });
  }

  private createJS(connectionType: string, callback: (type: string) => void, countriesList: string[], accept?: number) {
    ['inApp', 'mobileWeb', 'desktop'].forEach(adType => {
      this.formControls[adType]?.patchValue(this.adtype === adType);
    });

    ['min_rcpm', 'rtbConnectionMode', 'vastConnectionMode'].forEach(prop => delete this.formValue[prop]);

    const jsData = {
      ...this.formValue,
      nativeSpec: this.formValue['nativeSpec'].includes(-1) ? [1, 2, 3] : this.formValue['nativeSpec'],
      sspList: this.getModifiedSSPList(),
      connectionType,
      countriesList,
      accept: accept ?? undefined,
    };

    this.mainService.createNewDSP(this.modifyReqData(removedJsDSPFields, jsDSPCheckboxes, jsData))
      .pipe(finalize(() => this.isDisableSubmit = false))
      .subscribe({
        next: (resp: PlatformInterface.IUpdateDSPResponse) => {
          callback('created');
          this.isActiveEndpoint = false;
          this.newDSPForm.reset({}, { emitEvent: false });
          this.connectionType = 'rtb';
          this.sizesList = [];
          // Simplify dialog creation by extracting it into a separate method
          this.openEndpointLinkDialog(resp.data.endpoint, resp.data.name);
        },
        error: (error) => {
          this.isDisableSubmit = false;
          this.handleError(error, connectionType, callback);
        }
      });
  }

  private onCreateEndpointBaseOnConnectionType(connectionType: any, callback: (type: string) => void, countriesList: string[], accept?: number): void {
    switch (this.connectionType) {
      case 'rtb':
        this.createRTB(connectionType, callback, countriesList, accept);
        break;
      case 'vast':
        this.createVast(connectionType, callback, countriesList, accept);
        break;
      case 'prebid':
        this.createPreBid(connectionType, callback, countriesList, accept);
        break;
      case 'js':
        this.createJS(connectionType, callback, countriesList, accept);
        break;
    }
  }

  private fetchCompaniesByConnectionType() {
    this.companies = [];
    this.mainService.getAllCompaniesByConnectionType(this.preparedFilter)
      .subscribe(
        resp => {
          this.companies = resp.data;
          this.companies.unshift({
            id: -1,
            name: '+ Create New Company',
            terms: 30
          });
        },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private handlePreBidServers() {
    if (this.isPreBidConnection()) {
      this.serversPreBid = [];
      this.mainService.getAdaptersByType({ is_prebid: true, type: 'dsp' })
        .subscribe(
          res => {
            this.preBidServers = res;
            this.serversPreBid = this.preBidServers.map(({ id, name, config }) => ({ id, name, config }));
          },
          error => this.errorsHandlingService.handleError(error)
        );
    }
  }

  private getAdServers(): void {
    this.mainService.getAdServers()
      .subscribe(resp => {
        this.adServers = resp.data;
        this.adServers.map(item => {
          if (item.adTypes[this.adtype]) {
            this.servers.push({ id: item.id, name: item.name });
          }
        });
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getDSPAdapters(): void {
    this.mainService.getAdaptersByType({ is_prebid: false, type: 'dsp' })
      .subscribe(
        res => this.handleAdapterResponse(res),
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getExistingSourceSchainInfo(): void {
    this.sourceSchainService.onGetExistingSourceSchainRequest()
      .subscribe(res => {
        this.sspFileCnt = res.sspFileCnt;
        this.dspFileCnt = res.dspFileCnt;


        if (this.sspFileCnt === 0) {
          this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
          this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
        } else {
          this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
          this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
        }


        if (this.dspFileCnt === 0) {
          this.formControls['schain_source'].patchValue(null, { emitEvent: false });
          this.formControls['schain_source'].disable({ emitEvent: false });
        } else {
          this.formControls['schain_source'].patchValue(null, { emitEvent: false });
          this.formControls['schain_source'].enable({ emitEvent: false });
        }
      },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getSourceSchainItems(type: string): void {
    this.sourceSchainService.getSourceSchainListReq(type)
      .subscribe(res => {
        this.sourceSchainItems = res.data;
      },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getCompaniesForDropdowns(region: string): void {
    this.getCompaniesForDropdownsReq(region).subscribe(res => {
      this.companiesSSPDropdown = transformArray(res.ssp);
    },
      error => this.errorsHandlingService.handleError(error));
  }

  private getCompaniesForDropdownsReq(region: string): Observable<MainDashboardInterface.CompaniesDataRes> {
    const params = new HttpParams().append('without_deleted', true);

    return this.http.get<MainDashboardInterface.CompaniesDataRes>(`${this.apiUrl}/endpoints/grouped-by-company/ssp/${region}`, { params: params })
      .pipe(map(res => {
        res.ssp = res.ssp.map(company => {
          company.endpoints = company.endpoints.map(endpoint => {
            return { checked: false, disabled: false, label: endpoint.name, value: endpoint.id, ...endpoint };
          });
          return { checked: false, label: company.name, value: company.id, indeterminate: false, ...company };
        });

        return res;
      }),
        catchError(this.errorsHandlingService.processError));
  }
}
